import { useQuery } from "@tanstack/react-query";
import { getHomeCalendar } from "controller/api";
import type { HomeCalendarQuery } from "shared";
import { debugConsole } from "utilz/helpers";

/** One minute — the range is also kept live by MQTT, so this is just a floor. */
const CALENDAR_STALE_TIME = 60000;

interface UseGetHomeCalendarOptions {
  enabled?: boolean;
}

/**
 * Home screen calendar for a date range.
 *
 * No polling — freshness comes from the `dispatch/*` MQTT topics. The query key
 * is rooted at `home_calendar` so it never aliases the dispatch-portal branch's
 * own cache while both exist.
 */
export const useGetHomeCalendar = (
  params: HomeCalendarQuery,
  options?: UseGetHomeCalendarOptions,
) => {
  const { start, end, calendar_type, resources, boards } = params;

  return useQuery({
    queryKey: [
      "home_calendar",
      calendar_type ?? "team-member",
      start,
      end,
      resources?.join(",") ?? "",
      boards?.join(",") ?? "",
    ],
    queryFn: () => getHomeCalendar(params),
    enabled: options?.enabled ?? true,
    // Week paging keeps the previous week on screen until the new one lands.
    keepPreviousData: true,
    staleTime: CALENDAR_STALE_TIME,
    onError(err) {
      debugConsole("useGetHomeCalendar", err);
    },
  });
};
